import React, { useState, useRef } from 'react';

import { Popup } from "react-leaflet";

import DistanceSvg from '../../assets/i_distance.svg';
import ClockSvg from '../../assets/i_clock.svg';
import NotesSvg from '../../assets/i_notes.svg';
import SaveSvg from '../../assets/i_save.svg';
import DeleteSvg from '../../assets/i_delete.svg';

import {
    distanceInPreferredUnit,
    moveWaypoint,
    getAllWaypoints,
  } from '../../../services';

import { useDetailsContext } from '../details';

export const WaypointPopUp = ({ wpt, userPrefUnits, activityId, handleDeleteWaypoint, timeFormatError }) => {
    const [state, dispatch] = useDetailsContext();
    const [wptTitle, setWptTitle] = useState(wpt.title);
    const [wptDescription, setWptDescription] = useState(wpt.description);
    const [wptTime, setWptTime] = useState(wpt.elapsedTime ? wpt.elapsedTime.split(' ') : null);
    // const formRef = useRef(null); // create a ref for the form element
    const popupRef = useRef(null); // create a ref for the form element

    
    const handleWptTitleChange = (e) => {
        setWptTitle(e.target.value);
    };

    const handleWptDescriptionChange = (e) => {
        setWptDescription(e.target.value);
    };

    const handleWptTimeChange = (e) => {
        const time = e.target.value;
        let regex = /^([0-9]+):([0-5][0-9]):([0-5][0-9])$/;
        if (time.match(regex)) {
            setWptTime(e.target.value);
        } 
        else {
            console.log('format error');
            timeFormatError();
        }
        
    };
    
    const handleUpdateWaypoint = (e) => {
        e.preventDefault();
        
        // console.log('handleUpdateWaypoint');
        const title = wptTitle;
        const description = wptDescription ? wptDescription : "";
        const time = wptTime;

        moveWaypoint(wpt.id, wpt.index, title, description, time).then(() =>
            getAllWaypoints(activityId).then((res) =>
                dispatch({ type: 'FETCH_WAYPOINTS', payload: res })
            )
        );

        handleClosePopup();
    };

    const handleClosePopup = () => {
        if (popupRef && popupRef.current) {
            popupRef.current.options.autoClose = true;
            popupRef.current.closePopup();
            popupRef.current._closeButton.click();
        }
    }

    const handleClickDelete = (e) => {
        e.preventDefault();
        // console.log('handleClickDelete');
        handleDeleteWaypoint(wpt.id, activityId);
    };

    return (
        <Popup ref={popupRef}>
            <form id={`popup-form${wpt.id}`} onSubmit={handleUpdateWaypoint}>
                <div className="popup-header">
                    <input type="text" id={`wpt_title${wpt.id}`} placeholder="Waypoint Name" 
                    defaultValue={wpt.title} onChange={handleWptTitleChange}
                    name={`wpt_title${wpt.id}`} className="waypoint-title waypoint-input" />
                </div>
                <div className="popup-body">
                    <div className="popup-card">
                    <img src={ClockSvg} alt="elapsedTime"></img>
                    <input type="text" id={`wpt_time${wpt.id}`} 
                    defaultValue={wptTime[0]}  onChange={handleWptTimeChange}
                    name={`wpt_time${wpt.id}`} className="waypoint-time" step="1" />
                    </div>
                    <div className="popup-card">
                    <img src={DistanceSvg} alt="distance"></img>
                    <input type="text" id={`wptdistance${wpt.id}`} value={`${Math.round((distanceInPreferredUnit(wpt.distance) * 100) / 1000) / 100} ${userPrefUnits[1]}`}
                        disabled="disabled" readOnly="readonly" name={`wptdistance${wpt.id}`} className="waypoint-input" step="1" />
                    </div>
                    <div className="popup-notes">
                    <img src={NotesSvg} alt="description"></img>
                    <input type="text" id={`wptdescription${wpt.id}`} placeholder="Your Notes" 
                    defaultValue={`${wpt.description ? wpt.description : ''}`} onChange={handleWptDescriptionChange}
                    name={`wptdescription${wpt.id}`} className="waypoint-input" />
                    </div>
                <div className="popup-instructions">Tap/Click on the fields to edit. Drag to move
                </div>
                </div> 
                <div className="popup-footer">
                    <button id={`confirm${wpt.id}`} type="submit" className='btn btn-popup-save'><img src={SaveSvg} alt="Save"></img>  Save</button>
                    <button id={`delete${wpt.id}`} onClick={handleClickDelete} className='btn btn-popup-del'><img src={DeleteSvg} alt="Delete"></img>  Delete</button>
                </div>
            </form>
        </Popup>
    );
}